<template>
  <a-layout class="list-materials">
    <a-layout-header class="list-materials__header">
      <a-row class="list-materials__row">
        <a-col :span="20" class="list-materials__col">
          <a-input-search
            size="large"
            placeholder="Material"
            v-model="currentMaterial"
          />
        </a-col>
        <a-col :span="4" class="list-materials__col" style="padding-left: 6px;">
          <a-button @click="exportAllStamps()" type="primary" block>
            Export Stamps
          </a-button>
        </a-col>
      </a-row>
    </a-layout-header>
    <a-layout-content class="list-materials__content">
      <div v-for="group in resource" :key="group.id">
        <similar-group
          :group="group"
          :hideDelete="true"
          :hideUploadStamp="true"
        >
          <template v-slot:options>
            <a-popover title="Alert" v-if="isIllustrator">
              <template slot="content">
                <p v-if="groupHasCustomization(group)">
                  <b>{{ group.name }}</b> has a specific customization
                </p>
                <p v-else>
                  Create specific customization for <b>{{ group.name }}</b>
                </p>
              </template>
              <a-button
                type="link"
                size="small"
                @click="
                  open(
                    identifier,
                    findMaterial(group.devices.find((d) => !!findMaterial(d))),
                    true,
                    group.identifier,
                    product
                  )
                "
              >
                <a-icon
                  v-if="groupHasCustomization(group)"
                  type="star"
                  theme="filled"
                />
                <a-icon v-else type="star" />
              </a-button>
            </a-popover>
          </template>
          <template v-slot:device="{ device }">
            <a-card
              v-if="findMaterial(device)"
              :title="device"
              :class="
                supportedDevice(device) !== false
                  ? ''
                  : 'list-materials__content-low-opacity'
              "
            >
              <template slot="extra">
                <a-row type="flex" justify="center">
                  <a-col>
                    <a-button-group>
                      <a-popover
                        title="Active Device On Spree"
                        v-if="isIllustrator"
                      >
                        <a-button
                          type="link"
                          style="padding: 0 6px;"
                          @click="setSupportedDevice(device)"
                        >
                          <a-icon
                            type="check-circle"
                            :theme="supportedDevice(device) ? 'filled' : null"
                          />
                        </a-button>
                      </a-popover>
                      <a-popover title="Alert" v-if="isAdvancedUser">
                        <template slot="content">
                          <p v-if="deviceHasCustomization(group)">
                            <b>{{ device }}</b> has a specific customization
                          </p>
                          <p v-else>
                            Create specific customization for
                            <b>{{ device }}</b>
                          </p>
                        </template>
                        <a-button
                          type="link"
                          @click="
                            open(
                              identifier,
                              findMaterial(device),
                              true,
                              product
                            )
                          "
                          style="padding: 0 6px;"
                        >
                          <a-icon
                            v-if="deviceHasCustomization(device)"
                            type="star"
                            theme="filled"
                          />
                          <a-icon v-else type="star" />
                        </a-button>
                      </a-popover>
                      <a-popover title="Open in Prisma">
                        <a-button
                          type="link"
                          style="padding: 0 6px;"
                          :href="`https://prisma-stg.web.app/?identifier=${identifier}&material=${findMaterial(
                            device
                          )}`"
                          target="_blank"
                        >
                          <a-icon type="info-circle" />
                        </a-button>
                      </a-popover>
                    </a-button-group>
                  </a-col>
                </a-row>
              </template>
              <div style="width: 350px; height: 350px; position: relative;">
                <mask-preview
                  v-if="getPreview(findMaterial(device))"
                  :customization="getPreview(findMaterial(device))"
                  :material="findMaterial(device)"
                  @canvas="
                    (v) =>
                      beforeExports.push({
                        device,
                        value: v,
                      })
                  "
                />
              </div>
            </a-card>
          </template>
        </similar-group>
      </div>
    </a-layout-content>
    <un-supported-materials
      v-if="unSupportedMaterials && unSupportedMaterials.length"
      :un-supported-materials="unSupportedMaterials"
    />
  </a-layout>
</template>

<script>
import MaskPreview from "@/components/customization/mask-preview/MaskPreview.vue";

import SimilarGroup from "@/components/similar-group/SimilarGroup.vue";
import { getCaseDevices } from "@/api/factory-api/case-device-api/caseDevice.api.js";
import { getSimilarGroup } from "@/api/catalog-api/similar-group-api/similarGroup.api.js";
import { getPreviewsCustomizations } from "@/api/catalog-api/design-customization-api/designCustomization.api.js";

import UnSupportedMaterials from "@/components/un-supported-materials/UnSupportedMaterials.vue";

export default {
  components: { MaskPreview, SimilarGroup, UnSupportedMaterials },
  data() {
    return {
      groups: null,
      previews: null,
      currentMaterial: null,
      materials: null,
      devices: null,
      beforeExports: [],
      unSupportedMaterials: [],
    };
  },
  computed: {
    resource() {
      const { groups, currentMaterial } = this;
      if (!groups) return;
      if (!currentMaterial || currentMaterial === "") return groups;

      let values = JSON.parse(JSON.stringify(groups));

      values.map((group) => {
        group.devices = group.devices
          .map((device) => {
            if (device.indexOf(currentMaterial) !== -1) return device;
          })
          .filter((e) => !!e);
        return group;
      });

      return values;
    },
    isAdvancedUser() {
      return this.$store.getters.isAdvancedUser;
    },
    isIllustrator() {
      return this.$store.getters.isIllustrator;
    },
    identifier() {
      return this.$route.params.identifier;
    },
    product() {
      return this.$route.params.product;
    },
  },
  mounted() {
    const { identifier } = this;
    if (!identifier) this.$router.go(-1);

    // Get From Factory
    getCaseDevices().then((res) => {
      this.materials = res.materials;
      this.devices = res.devices;
    });

    getSimilarGroup().then((response) => (this.groups = response.groups));

    if (identifier)
      getPreviewsCustomizations(identifier).then(
        (response) => (this.previews = response)
      );
  },
  methods: {
    findMaterial(device) {
      const { availableMaterial } = this;
      if (availableMaterial(`standard-${device}`)) return `standard-${device}`;
      else if (availableMaterial(`standardinvition-${device}`))
        return `standardinvition-${device}`;
      else if (availableMaterial(`caseimpactslimstandard-${device}`))
        return `caseimpactslimstandard-${device}`;
      else if (availableMaterial(`deluxe-${device}`)) return `deluxe-${device}`;
      else if (availableMaterial(`standardgocustomized-${device}`))
        return `standardgocustomized-${device}`;
      else if (availableMaterial(`deluxemattegocustomized-${device}`))
        return `deluxemattegocustomized-${device}`;
      else if (availableMaterial(`caseslimguardclear-${device}`))
        return `caseslimguardclear-${device}`;
      else if (availableMaterial(`antiimpactoslimair-${device}`))
        return `antiimpactoslimair-${device}`;
      else if (availableMaterial(`casedeluxeslimfosco-${device}`))
        return `casedeluxeslimfosco-${device}`;
      else if (availableMaterial(`newecodeluxe-${device}`))
        return `newecodeluxe-${device}`;
      else return device;
    },
    availableMaterial(material) {
      return !this.materials || this.materials.includes(material);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    open(identifier, material, specific, group, product) {
      this.$router.push({
        name: "PrismaAdmin",
        params: {
          identifier,
          material,
          specific,
          product,
          group,
          from: "ListMaterials",
        },
      });
    },
    groupHasCustomization(group) {
      if (!this.previews || !this.previews.length) return;
      return !!this.previews.find((p) => p.group === group.identifier);
    },
    deviceHasCustomization(device) {
      if (!this.previews || !this.previews.length) return;
      const getDevice = (material) =>
        material ? material.split("-")[1] : null;
      return !!this.previews.find((p) => getDevice(p.material) === device);
    },
    getPreview(material) {
      const { groups, previews } = this;
      if (!previews || !previews.length) return;
      let custom;

      custom = previews.find((el) => el.material === material);
      const device = (value) => value.split("-")[1] || value;

      if (!custom)
        custom = previews
          .filter((el) => !!el.material)
          .find((el) => device(el.material) === device(material));

      let group = null;
      if (!group)
        group = groups
          .map((el) => {
            if (!el.devices) return;
            if (el.devices.find((d) => d === device(material)))
              return el.identifier;
          })
          .filter((el) => !!el);
      if (!custom && group)
        custom = previews.find((el) => group.indexOf(el.group) !== -1);
      if (!custom) custom = previews.find((el) => !el.material);

      return custom;
    },
    exportAllStamps() {
      const input = document.createElement("a");
      this.beforeExports.forEach((element) => {
        element.value((value) => {
          input.setAttribute("download", element.device);
          input.setAttribute("href", value.base64);
          input.click();
        });
      });
    },
    supportedDevice(device) {
      if (!this.product || !this.product.devices) return null;
      return this.product.devices.includes(device);
    },
    setSupportedDevice(device) {
      const onlyUnique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      const inList = this.unSupportedMaterials.filter(
        (m) => m.device === device
      );
      if (!inList.length) {
        const materials = this.materials
          .filter(onlyUnique)
          .filter((m) => m.split("-")[1] === device);
        this.unSupportedMaterials.push({ device, materials });
      } else {
        this.unSupportedMaterials = this.unSupportedMaterials.filter(
          (m) => m.device !== device
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.list-materials {
  min-height: 100%;

  .list-materials__header {
    background: $fifth_color;
  }

  .list-materials__content {
    background: $fifth_color;

    .list-materials__content-low-opacity {
      opacity: 0.3;
    }
  }

  .list-materials__row,
  .list-materials__col {
    display: flex;
    align-items: center;
  }

  .list-materials__row {
    height: 100%;
  }

  .list-materials__content {
    padding: 12px;
  }
}

.mockup-preview {
  width: 200px;
}

.select {
  width: 100%;
}
</style>
